// Clipboard + object ops. Legacy: copySelected/pasteFromClipboard (L5169-5202),
// duplicateSelected (L5559), deleteSelected (L5642).
// Fabric v7 (map §4.2): obj.clone(props) returns a Promise and copies the listed
// custom props for us — so the manual barcode/QR prop re-copy is no longer needed.
import { ActiveSelection, type FabricObject } from 'fabric'
import { getCanvas, state } from './state'
import { CANVAS_CUSTOM_PROPS } from './history'

let fabricClipboard: FabricObject | null = null

function isActiveSelection(o: FabricObject): boolean {
  return o.type === 'activeselection'
}

export async function copySelected(): Promise<void> {
  const obj = getCanvas().getActiveObject()
  if (!obj) return
  fabricClipboard = await obj.clone(CANVAS_CUSTOM_PROPS)
}

export async function pasteFromClipboard(): Promise<void> {
  if (!fabricClipboard) return
  const canvas = getCanvas()
  const cloned = await fabricClipboard.clone(CANVAS_CUSTOM_PROPS)
  canvas.discardActiveObject()
  cloned.set({
    left: (cloned.left ?? 0) + 15,
    top: (cloned.top ?? 0) + 15,
    evented: true,
    id: (cloned.type || 'obj') + '-' + Date.now(),
  } as any)

  if (isActiveSelection(cloned)) {
    ;(cloned as ActiveSelection).canvas = canvas
    ;(cloned as ActiveSelection).forEachObject((o) => {
      ;(o as any).id = (o.type || 'obj') + '-' + Date.now() + Math.random()
      canvas.add(o)
    })
    cloned.setCoords()
  } else {
    canvas.add(cloned)
  }
  canvas.setActiveObject(cloned)
  canvas.requestRenderAll()
}

export async function duplicateSelected(): Promise<void> {
  const canvas = getCanvas()
  const obj = canvas.getActiveObject()
  if (!obj) return
  const cloned = await obj.clone(CANVAS_CUSTOM_PROPS)
  cloned.set({
    left: (cloned.left ?? 0) + 15,
    top: (cloned.top ?? 0) + 15,
    id: (cloned.type || 'obj') + '-' + Date.now(),
  } as any)
  if (isActiveSelection(cloned)) {
    ;(cloned as ActiveSelection).canvas = canvas
    ;(cloned as ActiveSelection).forEachObject((o) => {
      ;(o as any).id = (o.type || 'obj') + '-' + Date.now() + Math.random()
      canvas.add(o)
    })
    cloned.setCoords()
  } else {
    canvas.add(cloned)
  }
  canvas.setActiveObject(cloned)
  canvas.requestRenderAll()
}

export function deleteSelected(): void {
  const canvas = getCanvas()
  const obj = canvas.getActiveObject()
  if (!obj) return
  if (isActiveSelection(obj)) {
    ;(obj as ActiveSelection).getObjects().forEach((o) => canvas.remove(o))
  } else {
    canvas.remove(obj)
  }
  canvas.discardActiveObject()
  canvas.requestRenderAll()
  // Phase 3: if batchHeaders.length, updateBatchFieldsToolbar()
  void state
}

export function selectAll(): void {
  const canvas = getCanvas()
  canvas.discardActiveObject()
  const sel = new ActiveSelection(canvas.getObjects(), { canvas })
  canvas.setActiveObject(sel)
  canvas.requestRenderAll()
}
